/* eslint-disable react/no-danger */
import { useEffect, useState, memo } from 'react';

import PropTypes from 'prop-types';
import { Collapse as BCollapse } from 'reactstrap';

import { alignerStoryPageExpanded } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { countryMap } from '../../language.config';

import '../../styles/revamp/clinic-locations-collapse.scss';
import '../../styles/collapse.scss';

function ClinicLocationsCollapse (props) {
  const { title, content } = props;

  const [isOpen, toggleIsOpen] = useState(false);
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const locale = i18n.activeLocale;

  useEffect(() => {
    toggleIsOpen(false);
  }, [locale]);

  return (
    <div className={`${isOpen ? 'active' : ''} collapse-wrapper`}>
      <div
        className="collapse-header"
        role="presentation"
        onClick={() => {
          toggleIsOpen(!isOpen);
          alignerStoryPageExpanded(countryMap[country], title);
        }}
      >
        <h3>
          {title}
        </h3>
        <span className="plus" />
      </div>
      <BCollapse isOpen={isOpen}>
        <div className="collapse-body">
          <ul>
            {content.map((item, index) => (
              <li className="collapse-body-location" key={`${index + 1}+1`}>
                {item}
              </li>))}
          </ul>

        </div>
      </BCollapse>
    </div>
  );
}

export default memo(ClinicLocationsCollapse);

ClinicLocationsCollapse.propTypes = {
  title: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.string)
};

ClinicLocationsCollapse.defaultProps = {
  title: '',
  content: []
};
